import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeadphones, faReceipt, faRetweet, faFileSignature, faUser } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

const SideMenu = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleSidebar = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <div>
            
            <div className={`md:block ${isMenuOpen ? 'block' : 'hidden'} min-h-screen border-r-2 mt-2 relative`} 
                 style={{ backgroundColor: '#ffffff', width: '210px', padding: '1px' }}>
                <h3 className="text-lg text-gray-400 font-semibold border-b mb-4">MENU</h3>
                <ul style={{ listStyle: 'none', padding: 0 }}>
                    <li className="mb-4 p-2 text-md rounded hover:bg-[#241C68] hover:text-white text-black">
                        <Link to="/">
                            <FontAwesomeIcon icon={faHeadphones} /> Dashboard
                        </Link>
                    </li>
                    <li className="mb-4 p-2 text-md rounded hover:bg-[#241C68] hover:text-white text-black">
                        <Link to="/CompensationProposal">
                            <FontAwesomeIcon icon={faReceipt} /> Compensation Proposal
                        </Link>
                    </li>
                    <li className="mb-4 p-2 text-md rounded hover:bg-[#241C68] hover:text-white text-black">
                        <Link to="/ErrorPage">
                            <FontAwesomeIcon icon={faRetweet} /> Emergency Proposal
                        </Link>
                    </li>
                    <li className="mb-4 p-2 text-md rounded hover:bg-[#241C68] hover:text-white text-black">
                        <Link to="/ErrorPage">
                            <FontAwesomeIcon icon={faFileSignature} /> Reports
                        </Link>
                    </li>
                </ul>

                {/* Bottom Profile Section */}
                <div className="absolute bottom-32 rounded-md border border-[#241C68] w-full p-2 bg-white">
  <div className="rounded-lg bg-cover bg-center">
    {'isLoggedIn' && (
      <>
        <h1 className="text-sm text-center font-semi-bold mb-2">PIU LOGIN</h1>
        <div className="bg-opacity-50 rounded-xl flex items-start justify-between space-x-2">
          <div className="relative w-14 h-14 flex-shrink-0">
            <img
              src={'profilePicUrl' || 'defaultProfilePic.jpg'} // Replace with actual default image path
              alt="User Icon"
              className="rounded-full shadow-lg border border-white cursor-pointer transition-transform duration-300 object-cover"
            />
          </div>
          <div className="flex flex-col">
            <h2 className="text-md font-semibold">Himanshu Joshi</h2>
            <h3 className="text-xs text-gray-500">{'Designation' || 'Clerk'}</h3>
            {/* Uncomment the line below if company information is needed */}
            {/* <p className="font-semibold text-rose-300">{userData?.company}</p> */}
          </div>
        </div>
      </>
    )}
    <button
    //   onClick={handleLogout} // Replace with the actual logout handler
      className="flex mx-auto mb-1 w-full justify-center items-center p-2 mt-6 rounded-md bg-[#241C68] hover:bg-[#494479] transition-colors duration-200 text-white"
    >
      <span className="text-lg">Logout</span>
    </button>
  </div>
</div>

            </div>
        </div>
    );
};

export default SideMenu;
